function SvgComponent(props) {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Property 1=Variant3">
        <g clip-path="url(#clip0_2597_884)">
          <g id="Group 1">
            <path
              id="Vector"
              d="M91.0952 117.288H68.9272V139.46H91.0952V117.288Z"
              fill="#121014"
            />
            <path
              id="Vector_2"
              d="M103.586 130.231H56.4367C49.6129 130.231 44.0811 135.764 44.0811 142.589V181.712C44.0811 188.537 49.6129 194.069 56.4367 194.069H103.586C110.41 194.069 115.942 188.537 115.942 181.712V142.589C115.942 135.764 110.41 130.231 103.586 130.231Z"
              fill="#EE6C4C"
            />
            <path
              id="Vector_3"
              d="M84.5248 29.0102L81.1524 28.8574L79.818 58.3152L83.1904 58.468L84.5248 29.0102Z"
              fill="#D65238"
            />
            <path
              id="Vector_4"
              d="M32.1277 71.1843L23.5618 70.7963C22.0718 70.7288 20.8092 71.8822 20.7417 73.3725L19.827 93.5657C19.7595 95.056 20.9126 96.3188 22.4026 96.3863L30.9685 96.7743C32.4585 96.8418 33.7211 95.6884 33.7887 94.1981L34.7033 74.0049C34.7709 72.5146 33.6177 71.2518 32.1277 71.1843Z"
              fill="#D65238"
            />
            <path
              id="Vector_5"
              d="M138.043 75.9819L129.477 75.5939C127.987 75.5264 126.725 76.6798 126.657 78.1701L125.742 98.3633C125.675 99.8536 126.828 101.116 128.318 101.184L136.884 101.572C138.374 101.639 139.636 100.486 139.704 98.9957L140.619 78.8025C140.686 77.3122 139.533 76.0494 138.043 75.9819Z"
              fill="#D65238"
            />
            <path
              id="Vector_6"
              d="M115.568 55.9015L47.7829 52.831C36.6077 52.3248 27.1381 60.9754 26.6318 72.1526L25.5826 95.3141C25.0763 106.491 33.7251 115.963 44.9002 116.469L112.685 119.539C123.86 120.045 133.33 111.395 133.836 100.218L134.885 77.0562C135.392 65.879 126.743 56.4077 115.568 55.9015Z"
              fill="#EE6C4C"
            />
            <path
              id="Vector_7"
              d="M97.9815 63.1711L64.6398 61.6608C51.5152 61.0663 40.3936 71.2259 39.799 84.353C39.2044 97.48 49.3619 108.604 62.4865 109.198L95.8282 110.708C108.953 111.303 120.074 101.143 120.669 88.0162C121.264 74.8891 111.106 63.7656 97.9815 63.1711Z"
              fill="#121014"
            />
            <circle
              id="ER"
              cx="97.9177"
              cy="82.2791"
              r="7.5"
              transform="rotate(2.59356 97.9177 82.2791)"
              fill="#FEFEFC"
            />
            <path
              id="Vector_8"
              d="M79.9033 93.741C75.7215 93.5516 72.458 90.0012 72.6485 85.7962C72.767 85.1256 72.9713 85.1348 73.3535 85.1521C73.7357 85.1694 74.0147 85.475 73.9974 85.8573C73.8416 89.2978 76.5246 92.2359 79.9644 92.3918C83.4042 92.5476 86.3419 89.864 86.4977 86.4235C86.6775 85.7557 86.8206 85.7622 87.2028 85.7795C87.585 85.7968 87.864 86.1023 87.8467 86.4846C87.6572 90.6672 84.1075 93.9314 79.9033 93.741Z"
              fill="#FEFEFC"
            />
            <path
              id="Vector_9"
              d="M82.4037 38.0397C87.3704 38.2647 91.5791 34.42 91.8042 29.4523C92.0292 24.4846 88.1853 20.2752 83.2186 20.0502C78.2518 19.8252 74.0431 23.6699 73.8181 28.6376C73.5931 33.6052 77.437 37.8147 82.4037 38.0397Z"
              fill="#EE6C4C"
            />
            <path
              id="EL"
              d="M56.1892 82.8916C55.7406 82.8712 55.3652 82.4751 55.3876 81.9803C55.41 81.4855 55.7916 81.1237 56.2683 81.1453L68.4404 81.6091L57.727 75.6117C57.3157 75.389 57.1712 74.8575 57.3872 74.4298C57.6032 74.0021 58.1158 73.8503 58.5272 74.0731L69.5691 80.2604C70.2262 80.6401 70.5577 81.3842 70.3539 82.1624C70.1514 82.9116 69.5108 83.4075 68.7538 83.3732L56.1892 82.8916Z"
              fill="#FEFEFC"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2597_884">
          <rect width="160" height="160" rx="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
